// Material Kit 2 React pages
import Somos from "pages/Somos";

export default function SomosPage() {
  return <Somos />;
}
